import IconButton from '../../components/icon-button/component-lib.esm.js';
import CloseIcon from '../../icons/component-lib.esm5.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';

//
var script = {
  components: {
    IconButton,
    CloseIcon
  },
  setup() {
    const theme = useTheme();
    return {
      color: theme.value.profile.btnBgColor
    };
  }
};
export { script as default };